import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { UserIcon, MapPinIcon, StarIcon, ArrowLeftIcon, CalendarIcon, ClockIcon, CheckIcon, XIcon } from 'lucide-react';
import BackButton from '../../components/UI/BackButton';
import SaveToFavorites from '../../components/UI/SaveToFavorites';
// Mock data - in a real app, this would come from an API
interface PortfolioItem {
  id: number;
  imageUrl: string;
  title: string;
  category: string;
  author: string;
  photographer: {
    name: string;
    id: string;
  };
}
interface ContentUsage {
  id: number;
  imageUrl: string;
  title: string;
  type: 'book' | 'merchandise';
  author: string;
  authorId: string;
  bookId?: string;
  productId?: string;
  releaseDate: string;
  genre: string;
  series?: {
    name: string;
    position: number;
  };
  designer?: {
    name: string;
    id: string;
  };
}
const modelsData = [{
  id: 1,
  name: 'Elena Martinez',
  location: 'Miami, FL',
  specialties: ['Romance Covers', 'Editorial', 'Commercial'],
  rating: 4.9,
  reviewCount: 87,
  imageUrl: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e',
  availability: 'Available Now',
  height: '5\'9"',
  measurements: '32-24-34',
  bio: "Professional model with 6+ years of experience specializing in romance and editorial book covers. I, ve, worked, with: over, 30: bestselling, authors, and, have, been, featured, on, covers, that, reached, the, USA, Today, and, New, York, Times, bestseller, lists, : ., ',: experience, '6 years",
  languages: ['English', 'Spanish'],
  hairColor: 'Brown',
  eyeColor: 'Hazel',
  bookings: [{
    month: 'June',
    availability: 'Limited'
  }, {
    month: 'July',
    availability: 'Available'
  }, {
    month: 'August',
    availability: 'Available'
  }],
  portfolio: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e',
    title: 'Sunset Romance',
    category: 'Romance Cover',
    author: 'Rebecca Stone',
    photographer: {
      name: 'Michael Chen',
      id: 'mc-123'
    }
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
    title: 'City Lights',
    category: 'Urban Romance',
    author: 'Michael Chen'
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb',
    title: 'Summer Heat',
    category: 'Contemporary Romance',
    author: 'Sarah Johnson'
  }, {
    id: 4,
    imageUrl: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df',
    title: 'The Awakening',
    category: 'Paranormal Romance',
    author: 'Thomas Gray'
  }, {
    id: 5,
    imageUrl: 'https://images.unsplash.com/photo-1524250502761-1ac6f2e30d43',
    title: 'Whispers of the Heart',
    category: 'Contemporary Romance',
    author: 'Elena Richards'
  }, {
    id: 6,
    imageUrl: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2',
    title: 'Forever Mine',
    category: 'Historical Romance',
    author: 'David Williams'
  }],
  contentUsage: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e',
    title: 'Midnight Whispers',
    type: 'book',
    author: 'Rebecca Stone',
    authorId: 'rebecca-stone',
    bookId: 'midnight-whispers',
    releaseDate: '2023-06-15',
    genre: 'Romance'
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330',
    title: 'City Lights',
    type: 'book',
    author: 'Michael Chen',
    authorId: 'michael-chen',
    bookId: 'city-lights',
    releaseDate: '2023-07-10',
    genre: 'Urban'
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb',
    title: 'Summer Heat',
    type: 'book',
    author: 'Sarah Johnson',
    authorId: 'sarah-johnson',
    bookId: 'summer-heat',
    releaseDate: '2023-08-15',
    genre: 'Contemporary'
  }],
  reviews: [{
    id: 1,
    author: 'Rebecca Stone',
    authorRole: 'Romance Author',
    rating: 5,
    comment: 'Elena was incredibly professional and brought exactly the mood I wanted for my book cover. The shoot was efficient and the results exceeded my expectations.',
    date: '2023-09-15'
  }, {
    id: 2,
    author: 'Michael Chen',
    authorRole: 'Photographer',
    rating: 5,
    comment: 'Working with Elena is always a pleasure. She understands lighting, positioning, and expressions perfectly, making my job as a photographer much easier.',
    date: '2023-08-22'
  }, {
    id: 3,
    author: 'Sarah Johnson',
    authorRole: 'Publisher',
    rating: 4,
    comment: 'Great model who delivered exactly what our author needed. Prompt, professional, and versatile.',
    date: '2023-07-10'
  }]
}, {
  id: 2,
  name: 'James Wilson',
  location: 'Chicago, IL',
  specialties: ['Fantasy Covers', 'Commercial', 'Fitness'],
  rating: 4.8,
  reviewCount: 62,
  imageUrl: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d',
  availability: 'Available from July',
  height: '6\'1"',
  measurements: '40-32-38',
  bio: 'Fitness model and actor specializing in fantasy, sci-fi and action book covers. My background in martial arts and stage combat allows me to bring dynamic poses and authentic action scenes to your cover concepts.',
  experience: '4 years',
  languages: ['English'],
  hairColor: 'Black',
  eyeColor: 'Brown',
  bookings: [{
    month: 'June',
    availability: 'Booked'
  }, {
    month: 'July',
    availability: 'Available'
  }, {
    month: 'August',
    availability: 'Available'
  }],
  portfolio: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d',
    title: 'Dragon Slayer',
    category: 'Fantasy Cover',
    author: 'Marcus Lee',
    photographer: {
      name: 'Jennifer Wu',
      id: 'jennifer-wu'
    }
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5',
    title: "The Warrior's Path",
    category: 'Epic Fantasy',
    author: 'Jennifer Wu'
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d',
    title: 'Night Hunter',
    category: 'Urban Fantasy',
    author: 'Tanya Roberts'
  }, {
    id: 4,
    imageUrl: 'https://images.unsplash.com/photo-1504257432389-52343af06ae3',
    title: "Gladiator's Return",
    category: 'Historical Fantasy',
    author: 'Robert Black'
  }],
  contentUsage: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d',
    title: 'Dragon Slayer',
    type: 'book',
    author: 'Marcus Lee',
    authorId: 'marcus-lee',
    bookId: 'dragon-slayer',
    releaseDate: '2023-05-20',
    genre: 'Fantasy'
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5',
    title: "The Warrior's Path",
    type: 'book',
    author: 'Jennifer Wu',
    authorId: 'jennifer-wu',
    bookId: 'the-warriors-path',
    releaseDate: '2023-04-15',
    genre: 'Epic'
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d',
    title: 'Night Hunter',
    type: 'book',
    author: 'Tanya Roberts',
    authorId: 'tanya-roberts',
    bookId: 'night-hunter',
    releaseDate: '2023-03-10',
    genre: 'Urban'
  }],
  reviews: [{
    id: 1,
    author: 'Marcus Lee',
    authorRole: 'Fantasy Author',
    rating: 5,
    comment: 'James brought my character to life exactly as I had imagined him. His ability to strike powerful poses that convey strength and heroism is unmatched.',
    date: '2023-05-20'
  }, {
    id: 2,
    author: 'Jennifer Wu',
    authorRole: 'Cover Designer',
    rating: 4,
    comment: 'Professional and versatile model who takes direction well and brings his own creative ideas to the shoot.',
    date: '2023-04-15'
  }]
}, {
  id: 3,
  name: 'Sofia Chen',
  location: 'Vancouver, CA',
  specialties: ['Romance Covers', 'Lifestyle', 'Editorial'],
  rating: 4.7,
  reviewCount: 54,
  imageUrl: 'https://images.unsplash.com/photo-1517841905240-472988babdf9',
  availability: 'Limited Availability',
  height: '5\'8"',
  measurements: '34-26-36',
  bio: "Editorial and book cover model with a background in dance. I specialize in creating fluid, emotional poses that capture the essence of romance and women, s, fiction, covers, : ., ',: experience, '5 years",
  languages: ['English', 'Mandarin'],
  hairColor: 'Black',
  eyeColor: 'Brown',
  bookings: [{
    month: 'June',
    availability: 'Limited'
  }, {
    month: 'July',
    availability: 'Limited'
  }, {
    month: 'August',
    availability: 'Available'
  }],
  portfolio: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1517841905240-472988babdf9',
    title: 'Autumn Hearts',
    category: 'Contemporary Romance',
    author: 'Elizabeth James',
    photographer: {
      name: 'Alex Thompson',
      id: 'alex-thompson'
    }
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1539758462369-43adaa19bc1f',
    title: 'The Dancer',
    category: "Women's Fiction",
    author: 'Maria Lopez'
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1534751516642-a1af1ef26a56',
    title: 'Whispers in Spring',
    category: 'Romance',
    author: 'David Chen'
  }],
  contentUsage: [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1517841905240-472988babdf9',
    title: 'Autumn Hearts',
    type: 'book',
    author: 'Elizabeth James',
    authorId: 'elizabeth-james',
    bookId: 'autumn-hearts',
    releaseDate: '2023-04-12',
    genre: 'Contemporary'
  }, {
    id: 2,
    imageUrl: 'https://images.unsplash.com/photo-1539758462369-43adaa19bc1f',
    title: 'The Dancer',
    type: 'book',
    author: 'Maria Lopez',
    authorId: 'maria-lopez',
    bookId: 'the-dancer',
    releaseDate: '2023-03-15',
    genre: "Women's Fiction"
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1534751516642-a1af1ef26a56',
    title: 'Whispers in Spring',
    type: 'book',
    author: 'David Chen',
    authorId: 'david-chen',
    bookId: 'whispers-in-spring',
    releaseDate: '2023-02-10',
    genre: 'Romance'
  }],
  reviews: [{
    id: 1,
    author: 'Elizabeth James',
    authorRole: 'Romance Author',
    rating: 5,
    comment: 'Sofia is incredible to work with. Her dance background gives her a unique ability to create graceful, emotional poses that perfectly capture the mood of romance covers.',
    date: '2023-04-12'
  }, {
    id: 2,
    author: 'Alex Thompson',
    authorRole: 'Photographer',
    rating: 4,
    comment: 'Professional, punctual, and very skilled. Sofia needs minimal direction and can quickly adapt to different concepts.',
    date: '2023-02-28'
  }]
}];
const ModelPortfolio = () => {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const [activeTab, setActiveTab] = useState<'portfolio' | 'reviews' | 'booking' | 'content'>('portfolio');
  // Find the model based on the ID from the URL
  const model = modelsData.find(m => m.id === parseInt(id || '0'));
  if (!model) {
    return <div className="min-h-screen bg-gray-50 py-8 px-4" data-id="element-15359" data-mp="3kh71r22we0ms">
        <div className="max-w-7xl mx-auto text-center" data-id="element-15360" data-mp="1dpo4eumu627l">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-15361" data-mp="1do4mkzlj7j3p">
            Model Not Found
          </h1>
          <p className="text-lg text-gray-600 mb-8" data-id="element-15362" data-mp="1imy18vck1g5g">
            The model you're looking for doesn't exist or has been removed.
          </p>
          <Link to="/talent/models" className="inline-flex items-center bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors" data-id="element-15363" data-mp="1nuxhnyddwwgv">
            <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-15364" data-mp="1wuav124mq56v" />
            Back to Models
          </Link>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-15365" data-mp="2bhvtgiqk7g8g">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15366" data-mp="26l5e5xmkwoo3">
        {/* Back Button */}
        <div className="mb-6" data-id="element-15367" data-mp="2kk52f466j1jq">
          <BackButton data-id="element-15368" data-mp="2kjdfehqnec52" />
        </div>
        {/* Model Header */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-8" data-id="element-15369" data-mp="2gj33ypk36tit">
          <div className="md:flex" data-id="element-15370" data-mp="2ggz18axxc0k4">
            <div className="md:w-1/3" data-id="element-15371" data-mp="q5m1h61ad63t">
              <img src={model.imageUrl} alt={model.name} className="w-full h-96 object-cover" data-id="element-15372" data-mp="q6nn24fxhazs" />
            </div>
            <div className="p-6 md:w-2/3" data-id="element-15373" data-mp="nl65l582gyex">
              <div className="flex justify-between items-start" data-id="element-15374" data-mp="noafmj87qodi">
                <div data-id="element-15375" data-mp="sjhendqjf4w3">
                  <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-15376" data-mp="sn59qhbmrzcx">
                    {model.name}
                  </h1>
                  <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-15377" data-mp="11lgwu9dagf0m">
                    <MapPinIcon className="h-4 w-4 mr-1" data-id="element-15378" data-mp="11jctbsjaxi0v" />
                    {model.location}
                  </div>
                </div>
                <div className="flex items-center bg-yellow-50 px-3 py-1 rounded-full" data-id="element-15379" data-mp="8y38v0rkitsn">
                  <StarIcon className="h-5 w-5 text-yellow-400 mr-1" data-id="element-15380" data-mp="dvwdhpd83fqt" />
                  <span className="font-medium text-gray-900" data-id="element-15381" data-mp="imuuys9y6jvn">
                    {model.rating}
                  </span>
                  <span className="text-gray-500 ml-1" data-id="element-15382" data-mp="3hdelbwszwmr8">
                    ({model.reviewCount} reviews)
                  </span>
                </div>
              </div>
              <div className="mb-6" data-id="element-15383" data-mp="3m9ljh3f5gtym">
                <h2 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-15384" data-mp="3esozg8eqe7wn">
                  About
                </h2>
                <p className="text-gray-600" data-id="element-15385" data-mp="39unetj1nq0j2">{model.bio}</p>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-15386" data-mp="34thlbj06a98h">
                <div data-id="element-15387" data-mp="30sxnsebot3lt">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-15388" data-mp="30tfl7ea35nvb">
                    Experience
                  </h3>
                  <p className="text-gray-900" data-id="element-15389" data-mp="2vv5mwut2e75h">{model.experience}</p>
                </div>
                <div data-id="element-15390" data-mp="2r22q8dszqhl2">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-15391" data-mp="2r1jjlt8sjfmc">Height</h3>
                  <p className="text-gray-900" data-id="element-15392" data-mp="2m4jdxjfusevr">{model.height}</p>
                </div>
                <div data-id="element-15393" data-mp="2h5pw5etja1ps">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-15394" data-mp="2h69douf9uo3a">
                    Hair Color
                  </h3>
                  <p className="text-gray-900" data-id="element-15395" data-mp="2d4waks3kcz02">{model.hairColor}</p>
                </div>
                <div data-id="element-15396" data-mp="28636fqa62kck">
                  <h3 className="text-sm font-medium text-gray-500" data-id="element-15397" data-mp="1yge4fayp81lo">
                    Eye Color
                  </h3>
                  <p className="text-gray-900" data-id="element-15398" data-mp="22ihjsaohnqc8">{model.eyeColor}</p>
                </div>
              </div>
              <div className="mb-6" data-id="element-15399" data-mp="1oj01me5p7bbu">
                <h2 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-15400" data-mp="1ok1aqd35lnqx">
                  Specialties
                </h2>
                <div className="flex flex-wrap gap-2" data-id="element-15401" data-mp="2h6vsv3ci0b18">
                  {model.specialties.map(specialty => <span key={specialty} className="px-3 py-1 bg-purple-100 text-purple-700 text-sm rounded-full" data-id="element-15402" data-mp="2m5p5yunvi00v">
                      {specialty}
                    </span>)}
                </div>
              </div>
              <div className="flex gap-4" data-id="element-15403" data-mp="30584qwusnz0i">
                <button className="px-4 py-3 border border-purple-600 text-purple-600 rounded-lg hover:bg-purple-50 transition-colors w-full" data-id="element-15404" data-mp="3045gyxsrqcot">
                  Save to Favorites
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Tabs */}
        <div className="mb-6 border-b border-gray-200" data-id="element-15405" data-mp="ohlf2ze8009g">
          <nav className="flex space-x-8" data-id="element-15406" data-mp="129jg0mxs2puj">
            <button onClick={() => setActiveTab('portfolio')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'portfolio' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-15407" data-mp="1299pmy8tmgob">
              Portfolio
            </button>
            <button onClick={() => setActiveTab('content')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'content' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-15408" data-mp="jj1rkujzagez">
              Content Usage
            </button>
            <button onClick={() => setActiveTab('reviews')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'reviews' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-15409" data-mp="1pyu8zi8vzfy4">
              Reviews ({model.reviews.length})
            </button>
            <button onClick={() => setActiveTab('booking')} className={`pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'booking' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-15410" data-mp="2nt4zcmj7q9j0">
              Availability
            </button>
          </nav>
        </div>
        {/* Tab Content */}
        {activeTab === 'portfolio' && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-id="element-15411" data-mp="36pn0fujyblrx">
            {model.portfolio.map(item => <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden group hover:-translate-y-1 transition-transform duration-200" data-id="element-15412" data-mp="1cerg5uzemi9b">
                <div className="aspect-[2/3] relative" data-id="element-15413" data-mp="102flsi06sifo">
                  <img src={item.imageUrl} alt={item.title} className="w-full h-full object-cover" data-id="element-15414" data-mp="v4drt2182ypf" />

                  {/* Save Button - visible on hover */}
                  <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-15415" data-mp="1ntb6ywa50fdy">
                    <SaveToFavorites itemId={`portfolio-${item.id}`} size="sm" data-id="element-15416" data-mp="1iurml0b6zbnp" />
                  </div>
                  {item.location && <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center" data-id="element-15417" data-mp="19t0ejot6isqo">
                      <div className="text-white text-center px-4" data-id="element-15418" data-mp="3uj9d9o33fd01">
                        <p className="font-medium mb-1" data-id="element-15419" data-mp="2uv0zx3aghj39">Location</p>
                        <p className="text-sm" data-id="element-15420" data-mp="2uwc1cwgfier7">{item.location}</p>
                      </div>
                    </div>}
                </div>
                <div className="p-4" data-id="element-15421" data-mp="2m1xpl3v3xmcu">
                  <h3 className="font-medium text-gray-900 mb-1" data-id="element-15422" data-mp="2m2z1fajy6cvm">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-500 mb-1" data-id="element-15423" data-mp="2h1t7j9ejwjki">{item.category}</p>
                  <div className="flex flex-wrap items-center text-xs text-gray-600 gap-1" data-id="element-15424" data-mp="3dt3sfs27py5t">
                    {item.photographer && <div className="flex items-center" data-id="element-15425" data-mp="34syndokhrbut">
                        <span data-id="element-15426" data-mp="34rdsfxu9lqwf">Photo by </span>
                        <Link to={`/talent/photographers/${item.photographer.id}/portfolio`} className="text-purple-600 hover:text-purple-800 ml-1" data-id="element-15427" data-mp="2zunat62tan8w">
                          {item.photographer.name}
                        </Link>
                      </div>}
                    {item.designer && <div className="flex items-center" data-id="element-15428" data-mp="1j9lfrdjg0rfy">
                        <span className="mx-1" data-id="element-15429" data-mp="1j80ktmt7v6hk">•</span>
                        <span data-id="element-15430" data-mp="1o8xz3ob3vgds">Design by </span>
                        <Link to={`/talent/designers/${item.designer.id}/portfolio`} className="text-purple-600 hover:text-purple-800 ml-1" data-id="element-15431" data-mp="1o74v6grvna9h">
                          {item.designer.name}
                        </Link>
                      </div>}
                  </div>
                </div>
              </div>)}
          </div>}
        {activeTab === 'content' && <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-id="element-15432" data-mp="2by0tlwqu93pp">
            {model.contentUsage.map(item => <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:-translate-y-1 transition-transform duration-200" data-id="element-15433" data-mp="hjzkmj1kr0bw">
                <Link to={item.type === 'book' ? `/book/${item.bookId}` : `/product/${item.productId}`} className="block" data-id="element-15434" data-mp="4ls19at1j7l7">
                  <div className="aspect-[2/3] relative" data-id="element-15435" data-mp="elixpi15vwnx">
                    <img src={item.imageUrl} alt={item.title} className="w-full h-full object-cover" data-id="element-15436" data-mp="shmmgvt9nct0" />

                    {item.series && <div className="absolute top-2 left-0" data-id="element-15437" data-mp="12atoc6ossaoc">
                        <div className="bg-purple-600 text-white text-xs font-bold px-2 py-1 rounded-r" data-id="element-15438" data-mp="xap88hrsxhyn">
                          {item.series.name} #{item.series.position}
                        </div>
                      </div>}
                    <div className="absolute bottom-2 right-2" data-id="element-15439" data-mp="1pw4e6purj762">
                      <div className="bg-amber-100 text-amber-800 text-xs font-medium px-2 py-1 rounded-full" data-id="element-15440" data-mp="1pwnk1875253q">
                        {new Date(item.releaseDate).getFullYear()}
                      </div>
                    </div>
                  </div>
                  <div className="p-4" data-id="element-15441" data-mp="1lu10dukmfqhm">
                    <h3 className="font-medium text-gray-900 mb-1" data-id="element-15442" data-mp="1lszbam6rt3gw">
                      {item.title}
                    </h3>
                    <div className="flex items-center gap-2 mb-2" data-id="element-15443" data-mp="173tgdaeytzet">
                      <Link to={`/author/${item.authorId}`} className="text-sm text-purple-600 hover:text-purple-800" data-id="element-15444" data-mp="1bxxnbto8e7fw">
                        {item.author}
                      </Link>
                      <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full" data-id="element-15445" data-mp="o71wozvihia8">
                        {item.genre}
                      </span>
                    </div>
                    {item.designer && <div className="text-xs text-gray-500" data-id="element-15446" data-mp="1vhzr2wzdcjjd">
                        Cover by{' '}
                        <Link to={`/talent/designers/${item.designer.id}/portfolio`} className="text-purple-600 hover:text-purple-800" data-id="element-15447" data-mp="1riz8nfksziww">
                          {item.designer.name}
                        </Link>
                      </div>}
                    {item.photographer && <div className="text-xs text-gray-500" data-id="element-15448" data-mp="17snju2nlqljp">
                        Photo by{' '}
                        <Link to={`/talent/photographers/${item.photographer.id}/portfolio`} className="text-purple-600 hover:text-purple-800" data-id="element-15449" data-mp="13t4zb7zp0che">
                          {item.photographer.name}
                        </Link>
                      </div>}
                  </div>
                </Link>
              </div>)}
          </div>}
        {activeTab === 'reviews' && <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-15450" data-mp="35ovoxoumeb1l">
            <div className="p-6" data-id="element-15451" data-mp="3agm4qacbtr0e">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-15452" data-mp="3ahf60vsinob5">
                Client Reviews
              </h2>
              <div className="space-y-6" data-id="element-15453" data-mp="3fexb2b3exjdv">
                {model.reviews.map(review => <div key={review.id} className="border-b border-gray-100 pb-6 last:border-b-0 last:pb-0" data-id="element-15454" data-mp="2ht9glvqipb4z">
                    <div className="flex justify-between mb-2" data-id="element-15455" data-mp="2rpmktnjov7dz">
                      <div data-id="element-15456" data-mp="2rs8p9eba96rz">
                        <h3 className="font-medium text-gray-900" data-id="element-15457" data-mp="2vrzh7lcjpsy3">
                          {review.author}
                        </h3>
                        <p className="text-sm text-gray-500" data-id="element-15458" data-mp="6z3vbygwobxv">
                          {review.authorRole}
                        </p>
                      </div>
                      <div className="flex items-center" data-id="element-15459" data-mp="2813gvc7fo37b">
                        {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < review.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} data-id="element-15460" data-mp="231qlg32hxnt4" data-mpi={i} />)}
                      </div>
                    </div>
                    <p className="text-gray-600 mb-2" data-id="element-15461" data-mp="1oex9n7s6r05o">{review.comment}</p>
                    <p className="text-sm text-gray-500" data-id="element-15462" data-mp="1kcty6j5invke">{review.date}</p>
                  </div>)}
              </div>
            </div>
          </div>}
        {activeTab === 'booking' && <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-15463" data-mp="1tbxjlts5on22">
            <div className="p-6" data-id="element-15464" data-mp="15n4kjog8lz38">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-15465" data-mp="15m375dbr10ic">
                Booking Availability
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-15466" data-mp="10o1f42wchquq">
                {model.bookings.map(booking => <div key={booking.month} className="border rounded-lg p-4" data-id="element-15467" data-mp="3h2d4u42nzuwj">
                    <div className="flex items-center justify-between mb-4" data-id="element-15468" data-mp="3h4hiveua2aaj">
                      <div className="flex items-center" data-id="element-15469" data-mp="33cjhjq6t5iox">
                        <CalendarIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-15470" data-mp="389jn7zzqwjfi" />
                        <h3 className="font-medium text-gray-900" data-id="element-15471" data-mp="3vznr88guil71">
                          {booking.month}
                        </h3>
                      </div>
                      {booking.availability === 'Available' ? <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-15472" data-mp="3m29as8ux9weq">
                          Available
                        </span> : booking.availability === 'Limited' ? <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full" data-id="element-15473" data-mp="2akq3o5e819aw">
                          Limited
                        </span> : <span className="px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full" data-id="element-15474" data-mp="37ajsibmkx43l">
                          Booked
                        </span>}
                    </div>
                    <div className="space-y-2" data-id="element-15475" data-mp="2xb1aw1u55uep">
                      <div className="flex items-center" data-id="element-15476" data-mp="2sc7ua0jk5nab">
                        {booking.availability === 'Available' ? <CheckIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-15477" data-mp="3py5afragtgj3" /> : booking.availability === 'Limited' ? <ClockIcon className="h-4 w-4 text-yellow-500 mr-2" data-id="element-15478" data-mp="3g9ndxm97xvl9" /> : <XIcon className="h-4 w-4 text-red-500 mr-2" data-id="element-15479" data-mp="3batwxjuq3mgc" />}
                        <span className="text-gray-600" data-id="element-15480" data-mp="ckaa2pavw1pi">
                          {booking.availability === 'Available' ? 'Open for bookings' : booking.availability === 'Limited' ? 'Some dates available' : 'Fully booked'}
                        </span>
                      </div>
                    </div>
                  </div>)}
              </div>
              <div className="mt-8" data-id="element-15481" data-mp="p5im1q7b2tag">
                <button className="bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors w-full" data-id="element-15482" data-mp="u2isw3bzc02m">
                  Make a Booking Enquiry
                </button>
                <p className="text-sm text-gray-500 text-center mt-2" data-id="element-15483" data-mp="132ff7yawcmui">
                  Send an enquiry to check detailed availability and discuss
                  your project
                </p>
              </div>
            </div>
          </div>}
      </div>
    </div>;
};
export default ModelPortfolio;